import * as React from "react";
import PropTypes from "prop-types";
import Button from "nx-components/Button";
import prefixStyles from "nx-components/utils/prefixStyles";

const buttonStyle = prefixStyles({
  flex: "1 1 auto",
  fontSize: "0.8em",
  marginBottom: "",
});

function DeviceControlButton({
  alert,
  buttonLabel,
  disabled,
  needsTrustedTap,
  onTap,
}) {
  return (
    <Button
      full
      disabled={disabled}
      needsTrustedTap={needsTrustedTap}
      onTap={onTap}
      theme={alert ? "alert" : undefined}
      style={buttonStyle}
    >
      {buttonLabel}
    </Button>
  );
}

DeviceControlButton.propTypes = {
  alert: PropTypes.bool,
  buttonLabel: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  needsTrustedTap: PropTypes.bool,
  onTap: PropTypes.func.isRequired,
};

export default DeviceControlButton;



// WEBPACK FOOTER //
// ./src/components/Controls/DeviceControlButton.jsx